// - Import external components
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import createSagaMiddleware, { END } from 'redux-saga';
import { createLogger } from 'redux-logger';
import { rootReducer } from 'store/reducers';
import { fromJS } from 'immutable';
// Create a history of your choosing (we're using a browser history in this case)
export var history = createHistory();
// Logger option for transforming immutable js
var logger = createLogger({
    stateTransformer: function (state) {
        return state.toJS();
    }
});
var sagaMiddleware = createSagaMiddleware();
// - initial state
var initialState = {};
// - Config and create store of redux
var composeEnhancers = composeWithDevTools({
// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
});
// let store: Store<any> = createStore(rootReducer, fromJS(initialState), composeEnhancers(
//   applyMiddleware(logger,thunk, routerMiddleware(history), sagaMiddleware)
// ))
var store = createStore(rootReducer, fromJS(initialState), composeEnhancers(applyMiddleware(thunk, routerMiddleware(history), sagaMiddleware)));
export default { store: store, runSaga: sagaMiddleware.run, customDispatch: function (disp) { return store.dispatch(disp); }, close: function () { return store.dispatch(END); }, history: history };



//////////////////
// WEBPACK FOOTER
// ./src/store/configureStore.dev.ts
// module id = 518
// module chunks = 50